export async function deleteUnexpectedStockOutflow(repository, id) {
  if (!id) {
    throw new Error('El ID es requerido')
  }

  try {
    await repository.delete(id)
    return true
  } catch (error) {
    throw new Error(error.message || 'Error al eliminar la salida extraordinaria')
  }
}

export default deleteUnexpectedStockOutflow 